import React, { useContext, useState } from 'react'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { Auth } from '../../../contexts/allContext'
import { useRequest } from '../../../hooks/useRequest'
import { subscriptionsName, targetAudience, yesNoOptions } from '../../../utils/static/static'
import PopupV1 from '../../Resources/PopupV1/PopupV1'
import classes from './CreateSubscription.module.css'

export default function EditSubscription({ form, setForm, plan, refresh }) {
    const { stateAuth } = useContext(Auth)
    const token = stateAuth.token
    const { handleSubmit } = useRequest()

    const [values, setValues] = useState({
        name: plan?.name ?? '',
        description: plan?.description ?? '',
        target_audience: plan?.target_audience ?? '',
        price_monthly: plan?.price_monthly ?? '',
        price_yearly: plan?.price_yearly ?? '',
        max_product_upload: plan?.max_product_upload ?? '',
        max_feature_product: plan?.max_feature_product ?? '',
        verified_badge: plan?.verified_badge ?? null,
        search_ranking: plan?.search_ranking ?? null,
        dedicated_support: plan?.dedicated_support ?? null,
    })

    const handleChange = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleSave = async () => {
        const payload = { ...values }

        try {
            const { isSuccess } = await handleSubmit(`v1/subscriptions/${plan.id}`, '', payload, token, 'PATCH')

            if (isSuccess) {
                toast.success('Subscription updated')
                setForm(false)
                refresh()
            }
        } catch (err) {
            console.error(err)
            toast.error('Failed to update subscription')
        }
    }

    return (
        <PopupV1 setForm={setForm} form={form} width="40%">
            <div className={classes.title}>
                <h2>Edit Subscription</h2>
            </div>

            <div className={classes.container}>
                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>Subscription Name</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={subscriptionsName}
                                classNamePrefix="react-select"
                                defaultValue={{ label: values.name, value: values.name }}
                                onChange={(e) => setValues({ ...values, name: e.value })}
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <label>Target Audience</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={targetAudience}
                                classNamePrefix="react-select"
                                defaultValue={{
                                    label: values.target_audience,
                                    value: values.target_audience,
                                }}
                                onChange={(e) => setValues({ ...values, target_audience: e.value })}
                            />
                        </div>
                    </div>
                </div>

                <div className={classes.formGroup}>
                    <label>Description</label>
                    <div className={classes.customDropDown}>
                        <textarea name="description" value={values.description} onChange={handleChange} />
                    </div>
                </div>

                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>Price Monthly</label>
                        <input
                            type="number"
                            name="price_monthly"
                            value={values.price_monthly}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={classes.formGroup}>
                        <label>Price Yearly</label>
                        <input type="number" name="price_yearly" value={values.price_yearly} onChange={handleChange} />
                    </div>
                </div>

                <div className={classes.formLayout2}>
                    <div className={classes.formGroup}>
                        <label>Max Product Upload</label>
                        <input
                            type="number"
                            name="max_product_upload"
                            value={values.max_product_upload}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={classes.formGroup}>
                        <label>Max Featured Product</label>
                        <input
                            type="number"
                            name="max_feature_product"
                            value={values.max_feature_product}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className={classes.formLayout}>
                    <div className={classes.formGroup}>
                        <label>Verified Badge</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                defaultValue={{
                                    label: values.verified_badge ? 'Yes' : 'No',
                                    value: values.verified_badge,
                                }}
                                onChange={(e) => setValues({ ...values, verified_badge: e.value })}
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <label>Search Ranking</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                defaultValue={{
                                    label: values.search_ranking ? 'Yes' : 'No',
                                    value: values.search_ranking,
                                }}
                                onChange={(e) => setValues({ ...values, search_ranking: e.value })}
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <label>Dedicated Support</label>
                        <div className={classes.customDropDown}>
                            <Select
                                options={yesNoOptions}
                                classNamePrefix="react-select"
                                defaultValue={{
                                    label: values.dedicated_support ? 'Yes' : 'No',
                                    value: values.dedicated_support,
                                }}
                                onChange={(e) => setValues({ ...values, dedicated_support: e.value })}
                            />
                        </div>
                    </div>
                </div>

                <div className={classes.buttonContainer}>
                    <button type="button" onClick={handleSave}>
                        Save Changes
                    </button>
                </div>
            </div>
        </PopupV1>
    )
}
